import { VButton, useUnleash, useVModal } from '@/package';
import { usePcdCacheStore, usePcdFileStore } from '@/store';
import { exportException } from '@/util';

export const TaskLayoutHeaderReportButton = () => {
  const { isEnabled } = useUnleash();
  const { openAlert, openPrompt } = useVModal();
  const isDisabledReportButton = isEnabled(
    'vuex.sapporo.disabledLabelingToolReportButton',
  );

  return (
    !isDisabledReportButton && (
      <div>
        <VButton
          size="sm"
          type="button"
          onClick={() => {
            openPrompt({
              title: 'Report',
              size: 'small',
              inputProps: {
                label: 'Report',
                placeholder: '증상을 입력해주세요',
              } as any,
              onConfirm: async e => {
                try {
                  const pcdStatusMap = await usePcdCacheStore
                    .getState()
                    .getPcdStatusMap(usePcdFileStore.getState().path);
                  const pcdPathMap = await usePcdCacheStore
                    .getState()
                    .getPcdPathMap(usePcdFileStore.getState().path);

                  await exportException.report({
                    message: e.target.value,
                    stack: null,
                    pathname: window.location.pathname,
                    datetime: new Date().toISOString(),
                    appVersion: import.meta.env.VITE_APP_VERSION,
                    userAgent: navigator.userAgent,
                    referrer: document.referrer,
                    pcdPathMap,
                    pcdStatusMap,
                  });

                  openAlert({
                    message: 'Report has been sent',
                    size: 'small',
                    title: 'Completed',
                  });
                } catch (error) {
                  console.warn(error);
                }
              },
            });
          }}
        >
          Report
        </VButton>
      </div>
    )
  );
};

TaskLayoutHeaderReportButton.displayName = 'TaskLayoutHeaderReportButton';
